﻿let $ = require('jquery');
let Q = require('q');
let _ = require('lodash');

const SuccessCode = 0;
const UnauthorizedCode = 8;
const UserNotFoundCode = 7;

module.exports = BillingInformation;

function BillingInformation(options) {
    this.luminateConfig = options.luminateConfig;

    this.container = options.container;
    this.inputs = {
        firstName: options.container.find('.donation-form-first-name'),
        lastName: options.container.find('.donation-form-last-name'),
        email: options.container.find('.donation-form-email'),
        zipCode: options.container.find('.donation-form-zip-code'),
        street1: options.container.find('.donation-form-street-address-1'),
        street2: options.container.find('.donation-form-street-address-2'),
        city: options.container.find('.donation-form-city'),
        state: options.container.find('.donation-form-state'),
        country: options.container.find('.donation-form-country'),
        title: options.container.find('.donation-form-title')
    };
}

BillingInformation.prototype = {
    getUserInformation() {
        return Q($.ajax({
            url: jnfroutesconfg.GetUserInfoUrl,
            type: 'POST',
            xhrFields: { withCredentials: true }
        }))
    },

    fillBillingInformation() {
        return this.getUserInformation()
            .then(this.parseResponse)
            .then(info => this.setInputValues(info));
    },

    setInputValues(info) {
        if (!info) { return; }

        this.inputs.firstName.val(info.name.first);
        this.inputs.lastName.val(info.name.last);
        this.inputs.email.val(info.email.primary_address);
        this.inputs.zipCode.val(info.primary_address.zip);
        this.inputs.street1.val(info.primary_address.street1);
        this.inputs.street2.val(info.primary_address.street2);
        this.inputs.city.val(info.primary_address.city);

        this.setSelectValue(this.inputs.state, info.primary_address.state);
        this.setSelectValue(this.inputs.country, info.primary_address.country);
        this.setSelectValue(this.inputs.title, info.name.title);
    },

    setSelectValue(element, value) {
        let availableOptions = _.map(element.children(), option => option.value);
        if (value && _.includes(availableOptions, value)) {
            element.val(value);
            element.addClass('selected');
        }
    },

    getDonateRequestData() {
        return {
            'billing.address.city': this.inputs.city.val(),
            'billing.address.state': this.inputs.state.val(),
            'billing.address.street1': this.inputs.street1.val(),
            'billing.address.street2': this.inputs.street2.val(),
            'billing.address.zip': this.inputs.zipCode.val(),
            'billing.address.country': this.inputs.country.val(),
            'billing.name.first': this.inputs.firstName.val(),
            'billing.name.last': this.inputs.lastName.val(),
            'billing.name.title': this.inputs.title.val(),
            'donor.email': this.inputs.email.val()
        };
    },

    validate() {
        let isValid = true;
        let requiredInput = this.container.find('.required-input');
        requiredInput.css('border', '1px solid #939598');
        $('p.required-warning').remove();
        for (let i = 0; i < requiredInput.length; i++) {
            if (!$(requiredInput[i]).val() || $(requiredInput[i]).val().length < 1) {
                $(requiredInput[i]).after('<p class="required-warning">required field</p>').css('border', '1px solid red');
                isValid = false;
            }
        }

        return isValid;
    },

    parseResponse(response) {
        switch (response.Result) {
            case SuccessCode: return response.Content;
            case UnauthorizedCode: return null;
            case UserNotFoundCode: throw new Error('User profile not found in luminate');
            default: throw new Error('Unknown Error occured while fetching User info');
        }
    }
}